import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Center, createColumnHelper, EmptyState, factory, Table, useProps, useStyles, useTable, useUncontrolled } from "@components/mantine";
import { AccessLevel, Platform, useQuery } from "@core/api";
import { useCallback, useMemo } from "react";
import { Locales } from "../../../strings/Locales.js";
import { AccessTableContextProvider } from "../AccessTable.context.js";
import { AccessTableAccessLevelCell } from "../AccessTableAccessLevelCell.js";
import { AccessTableConstants } from "../AccessTableConstants.js";
import { AccessTableUtils } from "../AccessTableUtils.js";
var defaultProps = {};
export var APIKeysAccessTable = factory(function(_props, ref) {
    var _ref = useProps("APIKeysAccessTable", defaultProps, _props), owner = _ref.privilegeOwner, targetDomain = _ref.privilegeTargetDomain, resourceId = _ref.resourceId, onChange = _ref.onChange, defaultValue = _ref.defaultValue, onInitialization = _ref.onInitialization, value = _ref.value, data = _ref.data, loading = _ref.loading, classNames = _ref.classNames, styles = _ref.styles, vars = _ref.vars, className = _ref.className, style = _ref.style, readOnly = _ref.readOnly, others = _object_without_properties(_ref, [
        "privilegeOwner",
        "privilegeTargetDomain",
        "resourceId",
        "onChange",
        "defaultValue",
        "onInitialization",
        "value",
        "data",
        "loading",
        "classNames",
        "styles",
        "vars",
        "className",
        "style",
        "readOnly"
    ]);
    var _$ref = _sliced_to_array(useUncontrolled({
        value: value,
        defaultValue: defaultValue,
        finalValue: null,
        onChange: onChange
    }), 3), _value = _$ref[0], handleChange = _$ref[1], isControlled = _$ref[2];
    var internalOnChange = useCallback(function(newValue) {
        if ((newValue === null || newValue === void 0 ? void 0 : newValue.length) > 0) {
            handleChange(newValue.sort(AccessTableUtils.sortIdNameModels));
        } else {
            handleChange === null || handleChange === void 0 ? void 0 : handleChange(AccessTableConstants.noAccess);
        }
    }, []);
    var table = useTable({
        initialState: {
            totalEntries: isControlled && data ? data.length : undefined
        }
    });
    var query = useQuery({
        enabled: !isControlled,
        queryKey: [
            "access",
            "api-keys",
            {
                targetDomain: targetDomain,
                owner: owner
            }
        ],
        queryFn: /*#__PURE__*/ _async_to_generator(function() {
            var accessModels, initialAccessModels, initialValue, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            Platform.organizationAccess.getApiKeys({
                                accessLevel: [
                                    AccessLevel.CUSTOM,
                                    AccessLevel.VIEW_ALL,
                                    AccessLevel.NONE,
                                    AccessLevel.EDIT_ALL
                                ],
                                privilegeOwner: owner,
                                privilegeTargetDomain: targetDomain
                            })
                        ];
                    case 1:
                        accessModels = _state.sent();
                        table.setTotalEntries(accessModels.length);
                        initialAccessModels = AccessTableUtils.overrideAccessModelsWithValue(accessModels, _value, resourceId);
                        initialValue = AccessTableUtils.serializeAccessModels(initialAccessModels, resourceId);
                        internalOnChange(initialValue);
                        onInitialization === null || onInitialization === void 0 ? void 0 : onInitialization(initialValue);
                        return [
                            2,
                            accessModels
                        ];
                    case 2:
                        error = _state.sent();
                        console.error(error);
                        return [
                            2,
                            []
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })
    });
    var getStyles = useStyles({
        name: "APIKeysAccessTable",
        classes: {},
        vars: vars,
        classNames: classNames,
        className: className,
        style: style,
        props: _props,
        styles: styles
    });
    var rows = useMemo(function() {
        var accessModels = isControlled ? data : query.data;
        return accessModels ? AccessTableUtils.sortModels(accessModels) : undefined;
    }, [
        isControlled,
        data,
        query.data
    ]);
    return /*#__PURE__*/ _jsx(AccessTableContextProvider, {
        value: {
            getStyles: getStyles,
            targetDomain: targetDomain,
            onChange: internalOnChange,
            value: _value,
            readOnly: readOnly
        },
        children: /*#__PURE__*/ _jsx(Table, _object_spread_props(_object_spread({
            ref: ref,
            store: table,
            data: rows,
            loading: isControlled ? loading : query.isLoading || _value === null,
            getRowId: function(row) {
                return row.id;
            },
            columns: columns
        }, others), {
            children: /*#__PURE__*/ _jsx(Table.NoData, {
                children: /*#__PURE__*/ _jsx(Center, {
                    children: /*#__PURE__*/ _jsxs(EmptyState, {
                        variant: "feedback",
                        children: [
                            /*#__PURE__*/ _jsx(EmptyState.Title, {
                                children: Locales.format("APIKeysAccessTable.emptyState.title")
                            }),
                            /*#__PURE__*/ _jsx(EmptyState.Image, {})
                        ]
                    })
                })
            })
        }))
    });
});
var columnHelper = createColumnHelper();
var columns = [
    columnHelper.accessor("displayName", {
        header: Locales.format("APIKeysAccessTable.headerLabel.apiKeys"),
        enableSorting: false
    }),
    columnHelper.accessor("accessLevel", {
        header: Locales.format("AccessTable.headerLabel.accessLevel"),
        enableSorting: false,
        cell: function(info) {
            return /*#__PURE__*/ _jsx(AccessTableAccessLevelCell, _object_spread({}, info.row.original));
        }
    })
];

//# sourceMappingURL=APIKeysAccessTable.js.map